import { SettingsUserGroupsUserGroupDto } from '../interfaces';
import { generateMockListResult } from '../../../lib';
import { mockUserGroupFields } from './userGroupMockFields';

export const getSettingsUserGroupsMockUserGroups = (options: {
    page: number;
    pageSize: number;
    totalCount?: number;
}) => {
    const { page = 0, pageSize = 10, totalCount = 51 } = options;

    return generateMockListResult<SettingsUserGroupsUserGroupDto>({
        fields: mockUserGroupFields,
        page,
        pageSize,
        totalCount,
    });
};
